import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { 
  FiZap, FiPhone, FiMail, FiMapPin, FiClock, 
  FiFacebook, FiInstagram, FiLinkedin, FiYoutube, FiCalendar 
} = FiIcons;

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/appointments', label: 'Book Appointment' },
    { path: '/contact', label: 'Contact' }
  ];

  const servicesList = [
    'Electrical Installation',
    'CCTV Systems',
    'Smart Home Automation',
    'Solar Power',
    'Security Systems',
    'Annual Maintenance'
  ];

  const contactInfo = [
    { icon: FiPhone, text: '+91 99066 69918', link: 'tel:+919906669918' },
    { icon: FiMail, text: 'tayyabelectricstudio@outlook.com', link: 'mailto:tayyabelectricstudio@outlook.com' },
    { icon: FiMapPin, text: 'Fatehgarh, Baramulla, J&K', link: 'https://maps.google.com' },
    { icon: FiClock, text: '24/7 Emergency Service', link: 'tel:+919906669918' }
  ];

  const socialLinks = [
    { icon: FiFacebook, link: 'https://www.facebook.com/tayyabelectricstudio', label: 'Facebook' },
    { icon: FiInstagram, link: 'https://www.instagram.com/tayyabelectricstudio', label: 'Instagram' },
    { icon: FiLinkedin, link: 'https://www.linkedin.com/company/tayyab-electric-studio-077437392', label: 'LinkedIn' },
    { icon: FiYoutube, link: 'https://www.youtube.com/channel/UCT6vi_i6l9ZYqXB9ih5phwg', label: 'YouTube' }
  ];

  return (
    <footer className="bg-gradient-to-b from-black to-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiZap} className="text-white text-xl" />
              </div>
              <div>
                <h3 className="text-xl font-bold gradient-text">Tayyab Electric</h3>
                <p className="text-xs text-gray-400">ARS Trading Corporation</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">Powering homes and securing futures with professional electrical and automation solutions across Kashmir for over 13 years.</p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a key={index} href={social.link} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-gradient-to-r hover:from-blue-600 hover:to-cyan-600 rounded-lg flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300" aria-label={social.label}>
                  <SafeIcon icon={social.icon} className="text-lg" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center space-x-2 group">
                    <span className="w-1 h-1 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Our Services</h4>
            <ul className="space-y-3">
              {servicesList.map((service, index) => (
                <li key={index}>
                  <Link to="/services" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center space-x-2 group">
                    <span className="w-1 h-1 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <span>{service}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Contact Info</h4>
            <ul className="space-y-4">
              {contactInfo.map((info, index) => (
                <li key={index}>
                  <a href={info.link} target={info.link.startsWith('http') ? '_blank' : '_self'} rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''} className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center space-x-3 group">
                    <SafeIcon icon={info.icon} className="text-lg text-blue-400 group-hover:text-cyan-400 transition-colors duration-300" />
                    <span className="text-sm">{info.text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-black border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center md:text-left">
          <p className="text-gray-400 text-sm">© 2024 Tayyab Electric Studio - A Unit of ARS Trading Corporation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;